import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './storage.service';
import { Router, RoutesRecognized } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { ToastrService } from 'ngx-toastr';
import { IdleManagerService } from './idle-manager.service';
import { filter, pairwise} from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { SignalrService } from './signalr.service';
import { AuthSession } from 'app/interfaces/authsession.interface';
import { BehaviorSubject } from 'rxjs';
import { GoogleLoginProvider, SocialAuthService } from 'angular12-social-login';
import { ScannerService } from './scanner.service';


declare var jQuery: any;
declare var async: any;

@Injectable()
export class AuthWebService {
  private static AUTHORIZATION: string = "Authorization";
  private static HEADERS = {};
  private static PENDING_REQUESTS = [];
  public isLoading = false;
  sessionId: string;
  isMachineKiosk = false;
  reload = new BehaviorSubject(false);
  isloggedout = false;


	constructor(
      private storageService: StorageService,  private authService: SocialAuthService, private http: HttpClient,private signalrService: SignalrService,private authentication:AuthenticationService,
      private router: Router, private toastr: ToastrService,
      private idleSrvc: IdleManagerService,    private scanner: ScannerService,) {
      AuthWebService.HEADERS['Content-Type'] = 'application/json';
      AuthWebService.HEADERS['Accept'] = 'application/json';

	}
 checkReload(data){
  this.reload.next(data);
 }
 getRealod(){
  return this.reload.asObservable();
 }
 loginWithDNN(data){
  return this.http.post(environment.authWebApi.url + '/api/UserService/LoginWithDNN' ,data)
 }

	public login(userName, password) {
    this.isLoading = true;

		//console.log("Start Authentication");this.http.get(environment.authWebApi.url + 'api/ConfigurationService/SystemConfig/'+environment.authWebApi.systemCode)
    this.webrequest('POST','UserService', 'Login', JSON.stringify({
			username: userName,
			password: password,
			systemcode: environment.authWebApi.systemCode
		})).then((data:any) => {
      this.isLoading = false;
      if(data === null){
        return this.toastr.warning('Account not activated, please check your email for activation.','Authentication failed')

      }
      
			if (data.IsAuthenticated) {
				environment.authWebApi.userData = data;
        this.storageService.setID(data.User.Id);
        this.storageService.setSessionId(data.User.Id);
        this.idleSrvc.setLoggedIn(data.IsAuthenticated);
        localStorage.setItem('isLogged','true');
        this.storageService.isLogged=true;
        let role:any=null;
        let userRoles:any=data.Roles.filter((map=>{return map.Code=='ADMIN'}));
        if(userRoles!=null && userRoles.length>0){
           role='ADMIN'; 
        }else{
          role='GUEST'
        }
         
      this.isKiosk();
      
       // this.signalrService.SessionManager(data.User.Id + '');
        
        let previousUrl:any=localStorage.getItem("previousUrl")!=undefined ? localStorage.getItem("previousUrl") : sessionStorage.getItem("previousUrl")!=undefined ? sessionStorage.getItem("previousUrl") : undefined;
        if(previousUrl!=undefined && (previousUrl.indexOf('process')>0 || previousUrl.indexOf('approval')>0) && role!=null && role=='ADMIN'){
          this.router.navigate([previousUrl]);
          localStorage.removeItem('previousUrl');
        }else{
          this.redirectTo('home');
        }
				
			}else if(data.IsAuthenticated == false && data.User != null){
        this.isLoading = false;
        this.toastr.error('Your Account is locked. A Password Reset Link was emailed to you.\n'+'Contact the administrator if the problem persists.\n'+'Tel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Authentication failed');
      }
      else {
        this.isLoading = false;
              //this.messageBox.warning('Authentication failed', 'Invalid usename or password. Please try again.');
              // this.dialogService.addDialog(AlertComponent, { title: 'Authentication failed', message: 'Invalid usename or password. Please try again.' });
              this.toastr.error('Contact the administrator if the problem persists.\n'+'Tel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Authentication failed');
		    }
          }, (error) => {
            this.isLoading = false;
            //console.log(userName+'----'+password);
            if(password==null || password ==undefined){
              
              this.toastr.error('You are unable to Log In without a Password.','Authentication failed');
            }else{
              this.toastr.error('Contact the administrator if the problem persists.\n'+'Tel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Authentication failed');
            }


            // this.dialogService.addDialog(AlertComponent, { title: 'Authentication failed', message: 'Contact the administrator if the problem persists.'});

			//his.messageBox.danger('Authentication failed','Authentication failed. Contact the administrator if the problem persists ');
		});
	}

  isKiosk(){

    // this.signalrService.getPCDetails().subscribe((result) =>{
    //   if(result){
    //      this.isMachineKiosk = true;
    //     this.runSignalRService();
    //   }
    // }, err =>{

    // });
  }

  runSignalRService(){
    if (localStorage.getItem("userID") !== null) {
      if (localStorage.getItem("sessionId") != null) {
        this.sessionId = localStorage.getItem("sessionId").toString();
      } else {
        this.sessionId = crypto.randomUUID();
        localStorage.setItem("sessionId", this.sessionId);
      }

      
      let authSession: AuthSession = {
        id: 0,
        carrierId: 0,
        sessionId: this.sessionId,
        pcIpAddress: this.signalrService.ipAddress,
        pcName: "",
        statusId: 1,
        connectionId: this.signalrService.connectionId,
        sessionStartTime: new Date(),
        sessionEndTime: new Date(),
        dateCreated: new Date(),
        dateModified: new Date(),
        userCreated: localStorage.getItem("userID"),
        userModifiedId: Number(localStorage.getItem("userID")),
        
      };

      this.signalrService.SessionManager(authSession);
    }
  }

	public logout() {

    console.log("Tryting to Logout");

    
   
    // this.scanner.relaunch();
     
  this.authService.authState.subscribe(
    (user) => {
      console.log("Google ", user)

      if(user != null || user != undefined) {
        // this.scanner.relaunch().subscribe(
        //   () => {
        //     console.log("DOne Relaunching")
        //   });

      }
    });

  if(this.userData.User.Authenticator ==="Google" && this.isMachineKiosk === true){
    // this.scanner.relaunch().subscribe(
    //   () => {
    //     console.log("DOne Relaunching");
    //   });
  }

    this.isloggedout = true;

    console.log("I just refreshed");
    this.authService.signOut(true);
    console.log("I just signedout");
   
		this.storageService.removeID();
    environment.authWebApi.userData = null;
    let previuosUrl:any=window.location.pathname;
    localStorage.clear();
    localStorage.removeItem("sessionId");
    localStorage.setItem('previousUrl',previuosUrl);
    this.checkReload(true);
   if(  this.isMachineKiosk === true){
    this.signalrService.stopConnection(this.signalrService.authSession);
  }



  this.redirectTo('login');
	
 
   
	}

  public register(auser: any) {
    //console.log(auser);
    this.isLoading = true;
   
    this.request('UserService', 'AddUser', {
      user: auser,
      SysCode: "ICBMS",
      activeLink: environment.activateLink.url,
    }).then((ur) => {
      //console.log(ur);
      if(ur === null){
        this.isLoading = false;
        return this.toastr.warning('User already exists!','Registration failed');
      }
      // this.dialogService.addDialog(AlertComponent, { title: 'User Registration', message: 'User registered successfully' });
      this.toastr.success('To complete your Registration, please check your Email or SMS to Activate your Login Account. This might take a few minutes','User Registration');
      this.isLoading = false;
      this.redirectTo('login');
      }, (error) => {
        //console.log(error);
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComporrnent, { title: 'Registration failed', message: 'Contact the administrator if the problem persists.' });
        this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Registration failed');
      });

	}
  public registerAzure(auser: any) {
    this.isLoading = true;
//console.log("AzuerUser");

    this.webrequest('POST','UserService', 'AddAzureUser', JSON.stringify({
      user: auser,
      SysCode: "ICBMS",
      activeLink: "url"
    })).then((data) => {
      
      this.isLoading = false;
      console.log("Returned data:");
      console.log(data);
      if (data.IsAuthenticated) {
				environment.authWebApi.userData = data;
        this.storageService.setID(data.User.Id);
        this.storageService.setSessionId(data.User.Id);
        this.idleSrvc.setLoggedIn(data.IsAuthenticated);
        localStorage.setItem('isLogged','true');
        this.storageService.isLogged=true;
        let role:any=null;
        let userRoles:any=data.Roles.filter((map=>{return map.Code=='ADMIN'}));
        if(userRoles!=null && userRoles.length>0){
           role='ADMIN'; 
        }else{
          role='GUEST'
        }
        let previousUrl:any=localStorage.getItem("previousUrl")!=undefined ? localStorage.getItem("previousUrl") : sessionStorage.getItem("previousUrl")!=undefined ? sessionStorage.getItem("previousUrl") : undefined;
        if(previousUrl!=undefined && (previousUrl.indexOf('process')>0 || previousUrl.indexOf('approval')>0) && role!=null && role=='ADMIN'){
          this.router.navigate([previousUrl]);
          localStorage.removeItem('previousUrl');
        }else{
          this.redirectTo('home');
        }
				
       } else if(data.IsAuthenticated == false && data.User != null){
          this.isLoading = false;
          this.toastr.error('Your Account is locked.\n'+'Contact the administrator to arrange for your profile to be unlocked.\n'+'Tel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Authentication failed');
        }
      else{
//console.log("returned data:")
//console.log(data);
this.isLoading = false;
       return this.toastr.error('Your credentials are incorrect','Login failed');

      }




     // this.redirectTo('home');
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComporrnent, { title: 'Registration failed', message: 'Contact the administrator if the problem persists.' });
        this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Registration failed');
      });

	}
  public ammendUser(auser: any, oldFirstName, oldLastName, oldemail, oldmobile) {
    //console.log("Start Authentication");
    this.isLoading = true;

    this.webrequest('GET','ConfigurationService', 'GetValue', JSON.stringify({
			systemCode: environment.authWebApi.systemCode,
			configCode: "ProfileMFA",
			defaultValue: null
		})).then(data => {
      if(data =="true")
      {
        let userObj = Object.create(auser);
        userObj.Id = auser.Id;
        userObj.FirstName = oldFirstName;
        userObj.LastName = oldLastName;
        userObj.EmailAddress =  oldemail ?? auser.EmailAddress;
        userObj.MobileNumber = oldmobile ?? auser.MobileNumber;
        userObj.DialCodeMobile = auser.DialCodeMobile;
        userObj.CommunicationType = auser.CommunicationType;
        userObj.SysCode = auser.SysCode;
        this.webrequest('POST','UserService', 'RequestOtp', userObj).then((ur) => {
        
          if(ur.success==true)
          {
            //show otp pop up
            document.getElementById('secretButton').click();
          }else{
            this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Failed to send OTP');
          }
      }, (error) => {
      	this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Failed to send OTP');
    		});
      }
      else {
        this.request('UserService', 'AmmendUser', auser 
        ).then((ur) => {
          // this.dialogService.addDialog(AlertComponent, { title: 'User Update', message: 'User updated successfully' });
          this.toastr.success('User updated successfully','User Update');
          this.isLoading = false;
          //this.redirectTo('login');
        }, (error) => {
          this.isLoading = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'User Update failed', message: 'Contact the administrator if the problem persists.' });
          this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','User Update failed');
        });
      }

    });
    
   

  }

	public accountManagement() {

    
  }
  public passwordResetRequest(emailAddress: any, systemcode:any, correspondencechoice:any) {
    ////console.log("Start Authentication");
    this.isLoading = true;
    this.request('UserService', 'InitiatePasswordReset', {
      emailAddress: emailAddress,
      systemcode: systemcode,
      correspondencechoice:correspondencechoice
    }).then((ur) => {
      console.log(ur)
      // this.dialogService.addDialog(AlertComponent, { title: 'Password Reset', message: 'An email has been sent to ' + emailAddress });
      //Checkig the server message from password reset service  
      if(ur.includes('failed')){
        this.toastr.warning(ur,'Password Reset');
        }else{
        this.toastr.success('A message has been sent','Password Reset');
        }
      this.isLoading = false;
      this.redirectTo('login');
      }, (error) => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Password Reset failed', message: 'Contact the administrator if the problem persists.' });
        this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Password Reset failed');

      });

  }

  public passwordResetConfirm(data){
    this.isLoading = true;
    this.request('UserService', 'CompletePasswordReset', {
      emailAddress: data.EmailAddress,
      passwordresettoken: data.ResetCode.toString(),
      newpassword:data.Password
    }).then((ur) => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Password Reset', message: 'Password has been reset' });
      this.toastr.success('Password has been reset','Password Reset');
      this.isLoading = false;
      this.redirectTo('login');
      }, (error) => {
        //console.log(error);
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Password Reset failed', message: 'Contact the administrator if the problem persists. '  });
        this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Password Reset failed');
      });

  }
  public activateAccout(emailAddress:string){
    this.isLoading = true;
    this.webrequest('POST','UserService', 'ActivateAccount', {
      email: emailAddress
    }).then((ur) => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Password Reset', message: 'Password has been reset' });
      this.toastr.success('Your Account was Activated Successfully.You may now proceed to login!','Account Activation');
      this.redirectTo('login');
     // this.router.navigate(['activate']);
    return true;
      }, (error) => {
        //console.log(error);
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Password Reset failed', message: 'Contact the administrator if the problem persists. '  });
        this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Account Activation');
        return false;
      });

  } 
	public get userData(): any {
		return environment.authWebApi.userData;
	}
	public get authenticated(): boolean {
		return (environment.authWebApi.userData) ? (environment.authWebApi.userData.IsAuthenticated)?true:false:false;
	}

	private redirectTo(url:string) {
		this.router.navigate([url]);
  }


  public request(service: string, method: string, parameters: any = {}, options: any = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      /*this.authentication.checkToken(() => {

          if (typeof (options.progressIndicator) === 'undefined') {
              options.progressIndicator = true;
          }*/

      let url = `${environment.authWebApi.url}/api/${service}/${method}`;
      let request = { url, options };

      /*if (this.authentication.authenticated && this.authentication.token) {
          WebApiService.HEADERS[WebApiService.AUTHORIZATION] = `Bearer ${this.authentication.token}`;
      } else {
          delete WebApiService.HEADERS[WebApiService.AUTHORIZATION];
      }

      WebApiService.addPendingRequest(request, this.messageBox);*/
      this.http.post(url, parameters, {
        headers: AuthWebService.HEADERS
      }).toPromise().then((result) => {
        //WebApiService.removePendingRequest(request, this.messageBox);
        resolve(result);
      }, (result) => {
        //WebApiService.removePendingRequest(request, this.messageBox);
        reject(new Error((result && result.error && result.error.Message) || result.message || result.statusText));
      });

    });
    //});
  }

  public registersociallogin(auser: any) {
    console.log("Start Authentication");
    this.isLoading = true;

    this.request('UserService', 'AddsocialLoginUser', {
      user: auser,
      SysCode: "ICBMS"
    }).then((data) => {
      console.log(data);
      this.isLoading = false;
            if (data.IsAuthenticated) {
                environment.authWebApi.userData = data;
                this.storageService.setID(data.User.Id);
                this.storageService.setSessionId(data.User.Id);
                this.idleSrvc.setLoggedIn(data.IsAuthenticated);
                localStorage.setItem('isLogged','true');
                this.storageService.isLogged=true;
                let role:any=null;
                let userRoles:any=data.Roles.filter((map=>{return map.Code=='ADMIN'}));
                if(userRoles!=null && userRoles.length>0){
                   role='ADMIN'; 
                }else{
                  role='GUEST'
                }
        
        this.isKiosk();

                let previousUrl:any=localStorage.getItem("previousUrl")!=undefined ? localStorage.getItem("previousUrl") : sessionStorage.getItem("previousUrl")!=undefined ? sessionStorage.getItem("previousUrl") : undefined;
                if(previousUrl!=undefined && (previousUrl.indexOf('process')>0 || previousUrl.indexOf('approval')>0) && role!=null && role=='ADMIN'){
                  this.router.navigate([previousUrl]);
                  localStorage.removeItem('previousUrl');
                }else{
                  this.redirectTo('home');
                }
              }
      }, (error) => {
        //console.log(error);
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComporrnent, { title: 'Registration failed', message: 'Contact the administrator if the problem persists.' });
        this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Registration failed');
      });

	}

  public userInfo = () => {
    let user = { username: "", emailAddress: "" };
    if (this.userData.User) {
      user.username = this.userData.User.FirstName + ' ' + this.userData.User.LastName;
      user.emailAddress = this.userData.User.EmailAddress;
    }
    return user;
  }

  checkByCode(arg0: any): any {
    throw new Error("Method not implemented.");
  }

  public getUserTimeout() {    
    // return this.request('ConfigurationService', 'GetInt', {
    //   systemCode: environment.authWebApi.systemCode,
    //   configCode: "UserTimeout1"
    // });
    return this.http.get(environment.authWebApi.url + '/api/ConfigurationService/GetInt/'+ environment.authWebApi.systemCode +'/'+"UserTimeout1/120");
  }
  SystemConfig(){
    return this.http.get(environment.authWebApi.url + '/api/ConfigurationService/SystemConfig/'+environment.authWebApi.systemCode)
  }
  public webrequest(action: string, service: string, method: string, parameters: any = {},  options: any = {}): Promise<any> {
		let pathparameters: string;
		let myArray: any;
		//console.log("Call: " + service +' : ' + ' : '+ method + ' : '+ 'parameters '  + parameters);
		if ( parameters != null && parameters != undefined && action != "POST" && action != "PUT" ) 
		{
			myArray = parameters.replace('{', '').replace('}', '').replace(/"/g, '').split(',');

		
			myArray.forEach(element => {

				if (pathparameters != null && pathparameters != undefined)
				{


					if (element.includes('password'))
					{

						pathparameters = pathparameters + '/' + element.split(':')[1].concat(':', element.split(':')[2]);
					}
					else
					{
						pathparameters = pathparameters + '/' + element.split(':')[1];
					}

				}
				else
				{

					pathparameters = '/' + element.split(':')[1];
				}


			});
		}
		else
		{
			pathparameters = '';
		}

	
		return new Promise((resolve, reject) => {
			/*this.authentication.checkToken(() => {

				if (typeof (options.progressIndicator) === 'undefined') {
					options.progressIndicator = true;
				}*/

				const url = `${environment.authWebApi.url}/api/${service}/${method}`;

				const request = { url, options };

				/*if (this.authentication.authenticated && this.authentication.token) {
					WebApiService.HEADERS[WebApiService.AUTHORIZATION] = `Bearer ${this.authentication.token}`;
				} else {
					delete WebApiService.HEADERS[WebApiService.AUTHORIZATION];
				}

				WebApiService.addPendingRequest(request, this.messageBox);*/
				//parameters = {}
				//console.log('Api Calls for ' + service + ' ' + method + ' parameters : ' + pathparameters);
		
				//switch statement to determine which call to make
				switch (action){
					case'GET':

					let finalurl = `${url}${pathparameters}`;

					this.http.get(finalurl, {
						headers: AuthWebService.HEADERS
					}).toPromise().then((result) => {
						resolve(result);
					}, (result) => {
						reject(new Error((result && result.error && result.error.Message) || result.message || result.statusText));
					});
					break;
					case 'PUT':
						
						this.http.put(url, parameters, {
							headers: AuthWebService.HEADERS
						}).toPromise().then((result) => {
							
							resolve(result);
						}, (result) => {
							
							reject(new Error((result && result.error && result.error.Message) || result.message || result.statusText));
						});
					break;
					case 'POST':
				
						this.http.post(url, parameters, {
							headers: AuthWebService.HEADERS
						}).toPromise().then((result) => {
						
							resolve(result);
						}, (result) => {
							
							reject(new Error((result && result.error && result.error.Message) || result.message || result.statusText));
						});
					break;
					case 'DELETE':
					let delurl = `${url}${pathparameters}`;

					this.http.delete(delurl, {
						headers: AuthWebService.HEADERS
					}).toPromise().then((result) => {
						resolve(result);
					}, (result) => {
						reject(new Error((result && result.error && result.error.Message) || result.message || result.statusText));
					});
					break;
					default:


				}
				///


			});
		//});
	}

}
